
    import { signIn } from '../../lib/auth.js';
    import { supabase } from '../../lib/supabase.js';

    const form = document.getElementById('loginForm');
    const errorMessage = document.getElementById('errorMessage');
    const submitBtn = document.getElementById('submitBtn');

    // Check if user is already logged in
    supabase.auth.onAuthStateChange((event, session) => {
      if (session) {
        window.location.href = '../../dashboard.html';
      }
    });

    form.addEventListener('submit', async (e) => {
      e.preventDefault();

      const email = document.getElementById('email').value;
      const password = document.getElementById('password').value;

      // Clear previous errors
      errorMessage.classList.add('hidden');
      errorMessage.textContent = '';

      // Disable button and show loading state
      submitBtn.disabled = true;
      submitBtn.innerHTML = `
        <iconify-icon icon="solar:spinner-linear" class="animate-spin text-lg mr-2"></iconify-icon>
        Signing in...
      `;

      try {
        const { data, error } = await signIn(email, password);

        if (error) {
          errorMessage.textContent = error.message || 'Invalid email or password';
          errorMessage.classList.remove('hidden');
          submitBtn.disabled = false;
          submitBtn.innerHTML = 'Sign In';
          return;
        }

        // Redirect to dashboard
        if (data.user) {
          window.location.href = '../../dashboard.html';
        }
      } catch (err) {
        errorMessage.textContent = 'An unexpected error occurred. Please try again.';
        errorMessage.classList.remove('hidden');
        submitBtn.disabled = false;
        submitBtn.innerHTML = 'Sign In';
      }
    });
  